import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import LanguageSelector from './LanguageSelector';
import { useTranslation } from '../hooks/useTranslation';

const Navigation = () => {
  const { t } = useTranslation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <>
      <nav 
        className="navigation-header"
        style={{
          background: isScrolled ? 'rgba(255, 254, 242, 0.98)' : 'rgba(255, 254, 242, 0.95)',
          boxShadow: isScrolled ? '0 2px 20px rgba(0, 0, 0, 0.05)' : 'none'
        }}
      >
        <div className="flex items-center justify-between w-full">
          {/* Logo */}
          <img 
            src="https://customer-assets.emergentagent.com/job_elite-properties-18/artifacts/69sbmjqc_MaisonEze.png" 
            alt="Maison Eze" 
            className="navigation-logo cursor-pointer"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          />
          
          {/* Desktop Menu */}
          <ul className="navigation-menu hidden md:flex">
            <li>
              <button onClick={() => scrollToSection('about')} className="navigation-link">
                {t.nav.about}
              </button>
            </li>
            <li>
              <button onClick={() => scrollToSection('destinations')} className="navigation-link">
                {t.nav.destinations}
              </button>
            </li>
            <li>
              <button onClick={() => scrollToSection('properties')} className="navigation-link">
                {t.nav.properties}
              </button>
            </li>
            <li>
              <button onClick={() => scrollToSection('partners')} className="navigation-link">
                {t.nav.partners}
              </button>
            </li>
            <li>
              <button onClick={() => scrollToSection('contact')} className="navigation-link">
                {t.nav.contact}
              </button>
            </li>
          </ul>
          
          {/* Language Selector and Mobile Menu */}
          <div className="flex items-center gap-4">
            <LanguageSelector />
            <button 
              className="md:hidden"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
      </nav>
      
      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div 
          className="fixed inset-0 z-50 md:hidden"
          style={{ background: 'rgba(255, 254, 242, 0.98)', paddingTop: '80px' }}
        >
          <div className="container py-8">
            <ul className="space-y-6">
              <li>
                <button 
                  onClick={() => scrollToSection('about')} 
                  className="navigation-link text-2xl block w-full text-left"
                >
                  About
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('destinations')} 
                  className="navigation-link text-2xl block w-full text-left"
                >
                  Destinations
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('properties')} 
                  className="navigation-link text-2xl block w-full text-left"
                >
                  Properties
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('partners')} 
                  className="navigation-link text-2xl block w-full text-left"
                >
                  Partners
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contact')} 
                  className="navigation-link text-2xl block w-full text-left"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>
        </div>
      )}
    </>
  );
};

export default Navigation;